var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "write-off-search",
        {
          ref: "writeOffSearch",
          attrs: {
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
            "config-module": "510",
            "grid-config-module": "191001",
            ar: _vm.ar,
            "is-bank-slip": _vm.isBankSlip,
            "is-real-send-receive": true,
            "arap-group": true,
            "cargo-grid-state-btn": false,
            "show-invoice-detail": true,
            "show-bill-payment-detail": true
          },
          on: {
            queryResultCallBack: _vm.queryResultCallBack,
            clickedCallBack: function(row) {
              return (_vm.clickRow = row)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { display: "inline" },
              attrs: { slot: "operations" },
              slot: "operations"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "newActualReceipt", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.newAmountHandler(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.newActualReceipt")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "newActualPayment", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.newAmountHandler(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.newActualPayment")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "edit",
                    type: "primary",
                    disabled: _vm.clickRow === null
                  },
                  on: { click: _vm.updateAmountHandler }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "invalid",
                    type: "danger",
                    disabled: _vm.clickRow === null
                  },
                  on: { click: _vm.invalidAmountHandler }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.invalid")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "viewWriteOffList",
                    type: "primary",
                    disabled: _vm.clickRow === null
                  },
                  on: { click: _vm.showWriteoffDetailHandler }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.viewWriteOffList")))]
              ),
              _vm.$checkPermission([
                "button_ACActual_modifyWriteoffMatchStatus"
              ])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "modifyMatchStatus", type: "primary" },
                      on: { click: _vm.modifyMatchStatusHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("WriteOff.modifyMatchStatus")))]
                  )
                : _vm._e(),
              _c(
                "el-dropdown",
                {
                  staticClass: "el-dropdown-spacing",
                  attrs: { "split-button": "", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.exportHandle()
                    },
                    command: function(p) {
                      _vm.exportCommand = p
                      _vm.exportHandle()
                    }
                  }
                },
                [
                  _vm.$t("CargoMsg.Cargo_Import") === _vm.exportCommand
                    ? _c(
                        "el-upload",
                        {
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            action:
                              _vm.URL.act.actualAmount
                                .receiptAndPaymentImportUrl,
                            data: {
                              branchId: _vm.$store.getters.currentOfficeId
                            },
                            headers: {
                              sessionId: _vm.$store.getters.userInfo.sessionId
                            },
                            "show-file-list": false,
                            accept: ".xls,.xlsx",
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadSuccess,
                            "on-error": _vm.handleError
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v(_vm._s(_vm.exportCommand))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.exportCommand === _vm.$t("SeaExport.TemplateDownload")
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.TemplateDownload")))
                      ])
                    : _vm._e(),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: _vm.$t("CargoMsg.Cargo_Import") } },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "batchImport",
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "5px"
                              },
                              attrs: {
                                action:
                                  _vm.URL.act.actualAmount
                                    .receiptAndPaymentImportUrl,
                                data: {
                                  branchId: _vm.$store.getters.currentOfficeId
                                },
                                headers: {
                                  sessionId:
                                    _vm.$store.getters.userInfo.sessionId
                                },
                                "show-file-list": false,
                                accept: ".xls,.xlsx",
                                "before-upload": _vm.beforeUpload,
                                "on-success": _vm.uploadSuccess,
                                "on-error": _vm.handleError
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "padding-left": "0px",
                                    color: "#6F6F6F",
                                    "text-align": "left",
                                    width: "80px"
                                  },
                                  attrs: { slot: "trigger", type: "text" },
                                  slot: "trigger"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Import"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t("SeaExport.TemplateDownload")
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.TemplateDownload")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.allowEdit
        ? _c("actual-dialog", {
            attrs: {
              visible: _vm.actualDialog.visible,
              params: _vm.actualDialog.params,
              ar: _vm.actualDialog.ar
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.actualDialog, "visible", $event)
              },
              refresh: _vm.refreshData
            }
          })
        : _vm._e(),
      _c("charge-write-off-detail-dialog", {
        attrs: {
          visible: _vm.chargeWriteOffDetailDialog.visible,
          "actual-amount-uuid": _vm.chargeWriteOffDetailDialog.actualAmountUuid,
          "is-ar": _vm.chargeWriteOffDetailDialog.isAr,
          "is-bill": _vm.chargeWriteOffDetailDialog.isBill,
          "is-setoff": _vm.chargeWriteOffDetailDialog.isSetoff,
          "total-group-type": _vm.chargeWriteOffDetailDialog.totalGroupType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargeWriteOffDetailDialog, "visible", $event)
          }
        }
      }),
      _c("modify-match-status-dialog", {
        attrs: {
          visible: _vm.modifyMatchStatusDialog.visible,
          "selected-rows": _vm.modifyMatchStatusDialog.selectedRows
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.modifyMatchStatusDialog, "visible", $event)
          },
          confirmSuccess: _vm.refreshData
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }